import instance from '../axios';

async function fetchAudiences() {
  const wrapper : HTMLElement = document.querySelector('.navigation-svelte');
  const lang = wrapper.dataset.language;
  try {
    const response = await instance.get('/sb/get-audiences', {
      params: {
        acf_format: 'standard',
        parent: 0,
        hide_empty: 'true',
        suppress_filters: 'true',
        lang,
      },
    });
    return JSON.parse(response.data);
  } catch (e) {
    return false;
  }
}

export default fetchAudiences;
